type PropTypes = {
  className?: string
}

const LeadingModeOfFailureIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="16"
        height="16.1363"
        fill="white"
        fillOpacity={0.01}
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M11.5 10.0852L10.7929 10.7983L12.0859 12.1022H3V2.01704H2V12.1022C2.0003 12.3696 2.10576 12.626 2.29323 12.815C2.4807 13.0041 2.73488 13.1104 3 13.1107H12.0859L10.7929 14.4147L11.5 15.1278L14 12.6065L11.5 10.0852Z"
        fill="#82848E"
      />
    </svg>
  )
}

export default LeadingModeOfFailureIcon
